"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const dump_truck_types_1 = require("./dump-truck.types");
const contractor_1 = require("services/master-data/contractor");
const dump_truck_1 = require("services/master-data/dump-truck");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, dump_truck_1._getMasterDumpTruck)(dataStates);
    if (response.isError) {
        dispatch({
            type: dump_truck_types_1.dumpTruckTypes.SET_ERROR, payload: {
                isError: response.isError,
                errorCode: response.errorCode, errorMessage: response.errorMessage
            }
        });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), status: item.is_active ? 'Active' : 'Inactive' });
            })
        };
        dispatch({ type: dump_truck_types_1.dumpTruckTypes.SET_DATA_GRID, payload });
    }
});
const closeError = () => dispatch => {
    dispatch({
        type: dump_truck_types_1.dumpTruckTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onDataStateChange = (dataStates) => dispatch => {
    const payload = {
        dataStates
    };
    dispatch({ type: dump_truck_types_1.dumpTruckTypes.ON_PAGE_CHANGE, payload });
};
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: dump_truck_types_1.dumpTruckTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { mutationMode } = payload;
    const response = payload.mutationMode == 'add' ?
        yield (0, dump_truck_1._createDumpTruck)({
            contractor_id: (_b = (_a = payload.dataItem) === null || _a === void 0 ? void 0 : _a.contractor) === null || _b === void 0 ? void 0 : _b.id,
            dumptruck_no: (_c = payload.dataItem) === null || _c === void 0 ? void 0 : _c.dumptruck_no,
            capacity_volume: (_d = payload.dataItem) === null || _d === void 0 ? void 0 : _d.capacity_volume,
            dumptruck_spec: payload.dataItem.dumptruck_spec,
            is_active: (_e = payload.dataItem) === null || _e === void 0 ? void 0 : _e.is_active.value,
            modified_by: payload.dataItem.modified_by
        }) :
        yield (0, dump_truck_1._editDumpTruck)({
            id: payload.dataItem.id,
            contractor_id: (_g = (_f = payload.dataItem) === null || _f === void 0 ? void 0 : _f.contractor) === null || _g === void 0 ? void 0 : _g.id,
            dumptruck_no: (_h = payload.dataItem) === null || _h === void 0 ? void 0 : _h.dumptruck_no,
            capacity_volume: (_j = payload.dataItem) === null || _j === void 0 ? void 0 : _j.capacity_volume,
            dumptruck_spec: payload.dataItem.dumptruck_spec,
            is_active: (_k = payload.dataItem) === null || _k === void 0 ? void 0 : _k.is_active.value,
            modified_date: new Date(),
            modified_by: payload.dataItem.modified_by,
            rfid_tag: payload.dataItem.rfid_tag
        });
    const dataItem = Object.assign(Object.assign({}, payload.dataItem), { id: response.data.id });
    const isSuccess = !response.isError;
    if (isSuccess)
        dispatch({ type: dump_truck_types_1.dumpTruckTypes.ON_SAVE_DATAITEM, payload: Object.assign(Object.assign({}, payload), { dataItem, mutationMode, isSuccess }) });
    else
        dispatch({
            type: dump_truck_types_1.dumpTruckTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage })
        });
});
const onDelete = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, dump_truck_1._deleteDumpTruck)({ id: payload.dataItem.id });
    const isSuccess = !response.isError;
    if (isSuccess)
        dispatch({ type: dump_truck_types_1.dumpTruckTypes.ON_DELETE, payload: Object.assign(Object.assign({}, payload), { isSuccess }) });
    else
        dispatch({
            type: dump_truck_types_1.dumpTruckTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage })
        });
});
const getDetail = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, contractor_1._getDropdownMasterContractorCoalMining)();
    const dataContractor = response.data;
    dispatch({ type: dump_truck_types_1.dumpTruckTypes.GET_DETAIL, payload: dataContractor });
});
const onFilterChange = payload => dispatch => {
    dispatch({ type: dump_truck_types_1.dumpTruckTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: dump_truck_types_1.dumpTruckTypes.ON_SORT_CHANGE, payload });
};
exports.default = {
    getDataGrid,
    onDataStateChange,
    onClickMutation,
    onSaveDataItem,
    getDetail,
    onDelete,
    onFilterChange,
    onSortChange,
    closeError
};
